import * as actions from "../action.constants";

const initialState = {
  customersList: {},
  selectedCustomer: {},
  customersListLabelValue: [],
};

const selectCustomer = (state, action) => {
  return {...state, selectedCustomer: action.selectedCustomer};
};

const saveGetCustomersList = (state, action) => {
  return {
    ...state,
    customersList: action.payload || {},
  };
};

const saveCustomersLabelValue = (state, action) => {
  return {
    ...state,
    customersListLabelValue: action.payload || [],
  };
};

const handlers = {
  [actions.SAVE_SELECTED_CUSTOMER]: selectCustomer,
  [actions.SAVE_GET_CUSTOMERS_LIST]: saveGetCustomersList,
  [actions.STORE_CUSTOMERS_LABEL_VALUE_LIST]: saveCustomersLabelValue,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
